import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';

// SERVICES/SERVICIOS  ----------------------------------------------------
import { GeneralService } from '@asambleas-services/general/general.service';
import { RegistrationService } from '@asambleas-services/registration/registration.service';
import { IglesiasService } from '@asambleas-services/iglesias/iglesias.service';
import { NotificationsService } from '@asambleas-services/notifications/notifications.service';
import { LoadService } from '@asambleas-components/loader/loader.service';
import { LoginUserRs } from '@asambleas-services/login/login.service';
import { AlertComponent } from '@asambleas-components/alert/alert.component';
import { Notification } from '@asambleas-models/notification.model';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

    // ATTRIBUTES/ATRIBUTOS  --------------------------------------------------
    registerForm: FormGroup;
    showForm2: boolean = false
    loader: any

    needChurch: { name: string, city_id: number, city: any } = null;

    churchWasSent: boolean = false;
    pendingChurchId: number;

    // CONSTRUCTOR  -----------------------------------------------------------
    constructor(
        private fb: FormBuilder,
        // private CustomValidators: ValidatorService,
        private general: GeneralService,
        private dialog: MatDialog,
        private router: Router,
        private registrationService: RegistrationService,
        private _iglesiasService: IglesiasService,
        private _notificationsService: NotificationsService,
        private loadService: LoadService
    ) {

        this.registerForm = this.fb.group({
            'ctrlDistrict': ['', Validators.required],
            'ctrlSectional': ['', Validators.required],
            'ctrlChurch': ['', Validators.required],

            'ctrlGender': ['', Validators.required],
            'ctrlFirstName': ['', Validators.required],
            'ctrlMiddleName': [''],
            'ctrlLastName': ['', Validators.required],
            'ctrlSecondLastName': [''],
            'ctrlDocumentType': ['', Validators.required],
            'ctrlNumberDocument': ['', Validators.required],
            'ctrlBirthDate': ['', Validators.required],
            'ctrlBornCity': ['', Validators.required],
            'ctrlMaritalStatus': ['', Validators.required],
            'ctrlResidenceCity': ['', Validators.required],
            'ctrlStreetType': ['', Validators.required],
            'ctrlStreetName': ['', Validators.required],
            'ctrlAddress1': ['', Validators.required],
            'ctrlAddress2': ['', Validators.required],

            'ctrlEmail': ['', Validators.required],
            'ctrlPassword': ['', Validators.required]
        });

    }

    ngOnInit() { }

    // Recibe el objeto enviado por el primer formulario
    FormForm1($event) {
        this.registerForm.patchValue($event)
        this.showForm2 = true
    }

    // Recibe el segundo objeto enviado por el primer formulario
    FormForm2($event) {
        this.registerForm.patchValue($event)
        console.log(this.registerForm.value)

        this.signUpWithEmail()
    }

    requestChurch($event) {
        this.needChurch = $event;
        console.log(this.needChurch);
    }

    signUpWithEmail() {
        this.loader = this.loadService.createLoad('');
        this.loader.open();

        let userData = {
            name: this.registerForm.value.ctrlFirstName,
            surname: this.registerForm.value.ctrlLastName,
            second_name: this.registerForm.value.ctrlMiddleName,
            second_surname: this.registerForm.value.ctrlSecondLastName,
            gender: this.registerForm.value.ctrlGender.value,
            document_type: this.registerForm.value.ctrlDocumentType.value,
            document_number: '' + this.registerForm.value.ctrlNumberDocument,
            birthdate: this.general.formatBirthDate(this.registerForm.value.ctrlBirthDate),
            birthplace: this.registerForm.value.ctrlBornCity.value,
            civil_status: this.registerForm.value.ctrlMaritalStatus.value,
            residence_address:
                this.registerForm.value.ctrlStreetType.description + ' ' + this.registerForm.value.ctrlStreetName + ' # ' +
                this.registerForm.value.ctrlAddress1 + ' - ' + this.registerForm.value.ctrlAddress2,
            residence_city: this.registerForm.value.ctrlResidenceCity.description,
            email: this.registerForm.value.ctrlEmail,
            is_academic: false,
            provider: 'email',
            password: this.registerForm.value.ctrlPassword,
            church_id: null
        }

        if (this.needChurch) {

            // SE AGREGA ESTA VALIDACIÓN, EN CASO DE QUE SE GENERE UN PROBLEMA EN EL REGISTRO DEL USUARIO SOLO CREARÁ UNA IGLESIA SOLICITADA Y NO SE DUPLICARÁ
            if (this.churchWasSent) {
                console.log('YA INGRESO LA IGLESIA');
                userData.church_id = this.pendingChurchId;
                this.sendData(userData);
            }
            else {
                this._iglesiasService.newPendingChurch(this.needChurch)
                    .subscribe((data: any) => {

                        console.log('IGLESIA PRIMERA VEZ CREADA');

                        userData.church_id = data.id;

                        this.churchWasSent = true;
                        this.pendingChurchId = userData.church_id;

                        console.log(this.pendingChurchId);

                        let notification = new Notification();
                        notification.title = 'Solicitud para crear Iglesia en el sistema';
                        notification.message = `La iglesia ${this.needChurch.name} en la ciudad ${data.city.name}(${data.city.sectional.name}/${data.city.sectional.district.name}) es solicitada por el nuevo miembro: `;

                        this.sendData(userData, notification);
                    }, (error) => {
                        console.log('Hubo un error');
                    })
            }


        }
        else {
            userData.church_id = this.registerForm.value.ctrlChurch.id
            this.sendData(userData);
        }

    }

    sendData(userData, notification_obj?: any) {

        const notification = new Notification(notification_obj);

        this.registrationService.userSignUp(userData).subscribe((data: LoginUserRs) => {
            localStorage.setItem('user', JSON.stringify(data.user))
            localStorage.setItem('id_token', data.id_token)

            if (notification) {
                notification.$message = notification.message.concat(`${data.user.name + ' ' + data.user.surname} (${data.user.id})`);
                this._notificationsService.sendNotificationToAdmins((notification))
                    .subscribe((data) => {
                        console.log('Notificacion enviada');
                    })
            }

            this.loader.close()
            this.router.navigate(['/admin']);
        }, (error) => {
            console.log('error', error)
            this.loader.close()

            let data = {
                title: 'Atención',
                content: 'Verifíque los datos ingresados. <br>'
            }

            Object.keys(error.error).forEach((key, index) => {
                data.content += '<br><span class="text-error"> * ' + error.error[key][0] + '</span>';
            });

            this.dialog.open(AlertComponent, {
                width: '35vw',
                disableClose: true,
                data: data
            })
        })
    }

    formatBirthDate() {
        let birthdate = this.registerForm.value.ctrlBirthDate
        let year = birthdate.getFullYear()
        let month = "" + (Number(birthdate.getMonth()) + 1)
        if (month.length < 2) {
            month = "0" + month.toString()
        }
        let day = "" + birthdate.getDate()
        if (day.length < 2) {
            day = "0" + day
        }

        let birthdateFormat = year + '-' + month + '-' + day

        return birthdateFormat
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/register/register.component.ts